import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "fluidHeight": "WidgetCmp-fluidHeight_1OTOU",
  "fixedWidth": "WidgetCmp-fixedWidth_t659k",
  "fixedHeight": "WidgetCmp-fixedHeight_17KOP"
};
function Widget({
  widgetFluidHeight,
  widgetFixedWidth,
  widgetFixedHeight,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles.fluidHeight]: widgetFluidHeight,
    [styles.fixedWidth]: widgetFixedWidth,
    [styles.fixedHeight]: widgetFixedHeight
  }, className);
  return /*#__PURE__*/_jsx(Base, {
    className: rootClasses,
    ...extraProps
  });
}
export default Widget;